import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_FACULTY,
  GET_FACULTIES,
  ADD_FACULTY,
  UPDATE_FACULTY,
  DELETE_FACULTY
} from '@/queries/modules/common-data/faculty';

export async function getFaculties(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_FACULTIES,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setFaculties', data.getFaculties);
      context.commit('setSuccess', null);
      return data.getFaculties
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getFaculty(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_FACULTY,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.faculty;
    } else {
      context.commit('setFaculty', data.getFaculty);
      context.commit('setSuccess', null);
      return data.getFaculty
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function addFaculty(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_FACULTY,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const faculties = [...context.state.faculties];
      faculties.push(data.addFaculty);
      context.commit('setFaculties', faculties);
      context.commit('setSuccess', newItemSuccess(data.addFaculty.nameLocal));

      return data.addFaculty
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateFaculty(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_FACULTY,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.faculties.findIndex(item => item.id === data.updateFaculty.id);
      const faculties = [
        ...context.state.faculties.slice(0, index),
        data.updateFaculty,
        ...context.state.faculties.slice(index + 1)
      ];
      context.commit('setFaculties', faculties);
      context.commit('setSuccess', updateItemSuccess(data.updateFaculty.nameLocal));

      return data.updateFaculty
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteFaculty(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_FACULTY,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.faculties.findIndex(item => item.id === data.deleteFaculty.id);
      const faculties = [
        ...context.state.faculties.slice(0, index),
        ...context.state.faculties.slice(index + 1)
      ];
      context.commit('setFaculties', faculties);
      context.commit('setSuccess', deleteItemSuccess(data.deleteFaculty.nameLocal));

      return data.deleteFaculty
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

